import { useQuery } from '@tanstack/react-query';
import type { ProjectStatus, TaskStatus } from '@stromo/shared';
import { api } from './api';

export interface GanttTask {
  id: number;
  project_id: number;
  section_id: number;
  title: string;
  status: TaskStatus;
  schedule_start: string | null;
  schedule_end: string | null;
  internal_start: string | null;
  internal_end: string | null;
}

export interface GanttSection {
  id: number;
  name: string;
  tasks: GanttTask[];
}

export interface GanttProject {
  id: number;
  order_number: string;
  title: string;
  status: ProjectStatus;
  start_date: string | null;
  end_date: string | null;
  project_manager_abbr: string | null;
  site_manager_abbr: string | null;
  /** Pro Sektion eine Liste der zugehörigen Aufgaben.
   *  Wird nur geliefert wenn include_tasks=true gesetzt war. */
  sections?: GanttSection[];
}

export interface GanttUtilisation {
  week_start: string;
  project_count: number;
}

export interface GanttResponse {
  items: GanttProject[];
  utilisation: GanttUtilisation[];
}

export interface GanttFilters {
  project_manager_id?: number;
  site_manager_id?: number;
  include_archived?: boolean;
  include_tasks?: boolean;
  from?: string;
  to?: string;
}

export function useGantt(filters: GanttFilters = {}) {
  return useQuery({
    queryKey: ['gantt', filters],
    queryFn: async () => {
      const params: Record<string, string | number> = {};
      if (filters.project_manager_id) params.project_manager_id = filters.project_manager_id;
      if (filters.site_manager_id) params.site_manager_id = filters.site_manager_id;
      if (filters.include_archived !== undefined) params.include_archived = String(filters.include_archived);
      if (filters.include_tasks !== undefined) params.include_tasks = String(filters.include_tasks);
      if (filters.from) params.from = filters.from;
      if (filters.to) params.to = filters.to;
      const { data } = await api.get<GanttResponse>('/gantt', { params });
      return data;
    },
  });
}
